import React from 'react'
import Layout from '../../Layout/Layout'
import Function_Cart from './Function_Cart'
import Footer from '../../Layout/Footer'
import FunctionCart3 from './FunctionCart3'
import FooterNew from '../../Layout/FooterNew'

function Cart() {
  return (
   <>
   <Layout/>
   <Function_Cart/>
   {/* <FunctionCart3/> */}
   {/* <Footer/> */}
   <FooterNew/>
   </>
  )
}

export default Cart
